import React from "react";
import Routes from "./Routes";
import ToastViewport from "components/ui/ToastViewport";

function App() {
  return (
    <>
      <Routes />
      <ToastViewport />
    </>
  );
}

export default App;
